import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import authService from "../services/authService";
import { validateEmail, validateMobile,  } from "../utils/Validations";
export default function Login() {
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false); 
  const navigate = useNavigate();
  const location = useLocation(); 
const {
  register,
  handleSubmit,
  formState: { errors },
} = useForm({
  mode: "onChange",
  reValidateMode: "onChange",
  defaultValues: {
    login: "",
    password: "",
  },
});
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const validateLogin = (value) => {
  const login = value?.trim() || "";

  if (!login) {
    return "Email or phone number is required.";
  }

  // If it contains @, validate as email
  if (login.includes("@")) {
    const emailResult = validateEmail(login);

    if (emailResult !== true) {
      return emailResult;
    }

    return true;
  }

  // Otherwise validate as mobile
  return validateMobile(login);
};
const onSubmit = async (formData) => {
  setError("");
  setIsLoading(true);

  try {
    const data = await authService.login({
      login: formData.login,
      password: formData.password,
    });

    if (!data || data.success === false) {
      throw new Error("Invalid credentials");
    }

    if (data.user?.user_role === "admin") {
      toast.error("Admin not allowed here. Please use Admin Login.");
      authService.logout?.();
      setIsLoading(false);
      return;
    }

    toast.success("Logged in successfully!");

    setTimeout(() => {
      setIsLoading(false);
      const redirectPath = location.state?.from || "/";
      navigate(redirectPath, { replace: true });
    }, 500);

  } catch (err) {
    toast.error("Invalid credentials");
    setIsLoading(false);
  }
};
  return (
    <div className="container-xxl">
      <div className="authentication-wrapper authentication-basic container-p-y">
        <div className="authentication-inner">
          <div className="card">
            <div className="card-body">
              <div className="app-brand justify-content-center mb-3">
                <Link to="/" className="app-brand-link gap-2">
                  <img src="/Fashion_logo.svg" alt="Logo" /> 
                </Link>
              </div>
              <h4 className="mb-2">Welcome to GDRB Fashion! 👋</h4> 
              <p className="mb-4">Please sign-in to your account</p>
              {error && <div className="alert alert-danger">{error}</div>}
              <form onSubmit={handleSubmit(onSubmit)} className="mb-3">
                {/* LOGIN FIELD */}
                <div className="mb-3">
                  <label className="form-label">
                    Email or Phone Number
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter email or phone number"
                  {...register("login", {
  validate: validateLogin,
})}
                  />
                  {errors.login && (
                    <p className="text-danger">{errors.login.message}</p>
                  )}
                </div>
                {/* PASSWORD FIELD */}
               <div className="mb-3 form-password-toggle">
  <div className="d-flex justify-content-between">
    <label className="form-label">Password</label>

    <Link to="/forgot-password">
      <small style={{ color: "#214b7a" }}>
        Forgot Password?
      </small>
    </Link>
  </div>

  <div className="input-group input-group-merge">
    <input
      type={showPassword ? "text" : "password"}
      className="form-control"
      placeholder="••••••••"
      {...register("password", {
        required: "Password is required.",
      })}
    />

    <span
      className="input-group-text cursor-pointer"
      onClick={togglePasswordVisibility}
    >
      <i
        className={
          showPassword
            ? "bx bx-show"
            : "bx bx-hide"
        }
      />
    </span>
  </div>

  {errors.password && (
    <p className="text-danger">
      {errors.password.message}
    </p>
  )}
</div>
                {/* SUBMIT */}
              <div className="mb-3">
  <button
    className="btn d-grid w-100"
    type="submit"
    disabled={isLoading}
    style={{ backgroundColor: "#214b7a", borderColor: "#2b4d74", color: "#fff" }}
  >
    {isLoading ? (
      <span className="spinner-border spinner-border-sm"></span>
    ) : (
      "Sign in"
    )}
  </button>
</div>
              </form>
              <p className="text-center">
                <span>New on our platform? </span>
                <Link to="/register" style={{color:"#214b7a"}}>Create an account</Link> 
              </p>  
              <div className="text-center">
                <Link to="/login/otp" style={{color:"#214b7a"}}>Login with OTP</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}